module.exports = __webpack_public_path__ + "img/城市相框.94366d07.jpg";